import { useEffect, useState, type FC } from 'react';
import 'react-phone-number-input/style.css';
import { usePlatformSettings, useWindowWidth } from '@shared/hooks';
import { ResetEmailStep } from '@src/modules/Authentication/frames/steps/reset-email-step/index.tsx';
import { CodeStep } from '../steps/code-step';
import { RepeatStepOne } from '../steps/repeat-step-one';
import { RepeatStepTwo } from '../steps/repeat-step-two';
import { ResetPassStep } from '../steps/reset-pass-step';
import { ResetPhoneStep } from '../steps/reset-phone-step';
import { useRestore } from './model';

interface Props {
  openLogin: () => void;
  openRegister: () => void;
}

export const Restore: FC<Props> = ({ openLogin, openRegister }) => {
  const restore = useRestore(
    () => openLogin(),
    () => openRegister()
  );

  const settings = usePlatformSettings();

  const windowWidth = useWindowWidth();

  const [type, setType] = useState(settings.first_method);

  useEffect(() => {
    setType(settings.first_method);
  }, [settings]);

  const [stepRepeat, setStepRepeat] = useState(1);

  return (
    <>
      {restore.step === 1.1 && <ResetPhoneStep model={restore} type={type} />}

      {restore.step === 1.2 && <ResetEmailStep model={restore} />}

      {restore.step === 2 && (
        <CodeStep
          model={restore}
          settings={settings}
          type={type}
          stepRepeat={stepRepeat}
          setStepRepeat={setStepRepeat}
        />
      )}

      {restore.step === 2.1 && (
        <RepeatStepOne model={restore} settings={settings} type={type} windowWidth={windowWidth} />
      )}

      {restore.step === 2.2 && (
        <RepeatStepTwo
          model={restore}
          settings={settings}
          type={type}
          windowWidth={windowWidth}
          setType={setType}
        />
      )}

      {restore.step === 3 && <ResetPassStep model={restore} />}

      {/*{restore.step === 4 && <SupportStep model={restore} />}*/}
    </>
  );
};
